export const DEFAULT_POP_SIZE = 100
export const DEFAULT_GENERATIONS = 1000
export const DEFAULT_ELITE = (popSize: number) =>
  Math.max(1, Math.floor(0.02 * popSize))
export const DEFAULT_CX_PROB = 0.8
export const DEFAULT_MUT_PROB = 0.2
export const DEFAULT_CROSSOVER_CHILDREN = 1
export const DEFAULT_IMMIGRATION = 0.02
export const DEFAULT_TOURNAMENT = 3
export const DEFAULT_STALL = 50
export const DEFAULT_TARGET_FITNESS = Infinity
export const DEFAULT_MAX_WALL_MS = Infinity
export const DEFAULT_MAX_EVALUATIONS = Infinity
export const DEFAULT_CONCURRENCY = 1

